import './Info.css';
const Info = ({comment,isMe})=>{

  function myInfo(){
    return isMe ? (   
    <>         
      <div className='me'>
      {comment.user.username}
      </div>
      <div className="you">you</div>
    </>
    ):(
      <div className='me'>
      {comment.user.username}
      </div>
    )

  }
    return (
        <div className="info">
        <div className="user">
          <div className='photo'>
            <img src={comment.user.image.png} alt ='profile'/>
          </div>
          <div className='name'>
            {myInfo()}
            </div>
        </div>
        <div className="time">
          {comment.createdAt}
        </div>
      </div>
    )
}

export default Info;
